import React, { Component } from 'react';
import { isEmpty, getLocale, handleDownloadCSV } from '../../Common/Common';
import Calendar from '../../Part_Sample/Calendar';
import Top_Bar from '../../Part_Sample/Top_Bar';
import Chart_Energy_Water from '../../Part_Sample/Chart_Energy_Water';

import {
	getChartMonthSelect, getYearSelectWithStartDate, getYearSelect, getEnergyWaterChartData, getEWManagementPoints,
	getMonthEndDate, getDefaultMonth
} from '../util/util';
import { navigateReport } from '../../Common/navigation';

export default class Energy_Water_Management extends Component {
	constructor(props) {
		super(props);

		this.lastClickTime = false;

		let tab = 'day';
		if (this.props.param.tab != null) tab = this.props.param.tab;

		let meter_info = {};
		if (this.props.param.meter_info != null) meter_info = this.props.param.meter_info;

		let selected_date = new Date();
		if (this.props.param.search_date != null) selected_date = this.props.param.search_date;

		this.search_date = selected_date;

		let selected_month = selected_date.getMonth();
		let selected_year = selected_date.getFullYear();

		selected_month = getDefaultMonth(this.props.param.report_settings, selected_year, selected_month)

		// Default categories
		this.categories = {
			"is_show_energy_categories": false,
			"is_energy_enabled": false,
			"is_energy_generator_enabled": false,
			"is_water_consumption_enabled": false,
			"is_recycled_water_enabled": false,
			"energy": {},
			"energy_generator": {
				"name": "energy_generator",
				"is_enabled": false,
				"points": [],
			},
			"water_consumption": {
				"name": "water_consumption",
				"is_enabled": false,
				"points": [],
			},
			"recycled_water": {
				"name": "recycled_water",
				"is_enabled": false,
				"points": [],
			}
		}
		if (!isEmpty(this.props.param.report_settings)) {
			if (!isEmpty(this.props.param.report_settings.categories)) this.categories = this.props.param.report_settings.categories;
		}

		this.state = {
			tab: tab,

			is_show_calendar: false,
			selected_date: selected_date,

			selected_month: selected_month,
			m_selected_year: selected_year,
			y_selected_year: selected_year,
			// For display in year info in year chart
			year_info: [],
			is_show_year_info: false,

			chart_data: getEnergyWaterChartData(this.props.param.report_type, meter_info, tab, selected_date, this.categories),
		}

		this.chart = React.createRef();

		// First time opening month tab
		this.is_default_month = true;
	}

	preventMultipleTaps = () => {
		if(this.lastClickTime == false) {		//Check if it is first click, allow
			this.lastClickTime = true;
			return true;
		} else {
			return false;
		}
	}

	handlePrevious = () => {
		if (this.props.param.from == 'Layout') {
			window.app.content_area.current.switch_content.current.handleShowBottomMenu();
			window.app.receiver.stored_params.layout_id = this.props.param.layout_id;
			window.app.receiver.next_component = 'Layout';
			window.app.receiver.getGroups();
		} else {
			window.app.content_area.current.switch_content.current.handleShowBottomMenu();
			navigateReport("null");
		}
	}

	handleShow = (key) => {
		if (!this.preventMultipleTaps()) return;

		this.setState({
			tab: key
		}, this.handleQuery)
	}

	toggleCalendar = () => {
		this.setState({ is_show_calendar: !this.state.is_show_calendar })
	}

	handleChangeCalDate = (selected_date) => {
		if (!this.preventMultipleTaps()) return;

		this.setState({
			selected_date: selected_date,
			is_show_calendar: false
		}, this.handleQuery);
	}

	handleChangeYear = (year) => {
		if (!this.preventMultipleTaps()) return;

		if (this.state.tab == 'month') {
			this.setState({
				m_selected_year: year
			}, this.handleQuery);
		} else if (this.state.tab == 'year') {
			this.setState({
				y_selected_year: year
			}, this.handleQuery);
		}
	}

	handleChangeMonth = (month) => {
		if (!this.preventMultipleTaps()) return;

		this.setState({
			selected_month: month
		}, this.handleQuery);
	}

	handleQuery = () => {
		window.app.showLoading();

		let points = getEWManagementPoints(this.categories, this.props.param.report_type);
		let start_date = new Date();
		let end_date = new Date();

		if (this.state.tab == 'day') {
			let search_details = {
				year: this.state.selected_date.getFullYear(),
				month: this.state.selected_date.getMonth() + 1,
				day: this.state.selected_date.getDate(),
				points: points,
			};

			this.search_date = this.state.selected_date;
			this.props.receiver.getHourlyMeter(search_details);
		} else if (this.state.tab == 'month') {
			// Check for report_settings start_date/month
			let date = 1;
			if (!isEmpty(this.props.param.report_settings)) {
				if (this.props.param.report_settings.start_day != null) date = this.props.param.report_settings.start_day;
			}

			start_date.setYear(this.state.m_selected_year);
			start_date.setMonth(this.state.selected_month);
			start_date.setDate(date);

			end_date = getMonthEndDate(start_date);
			// DB time end date is 0000 hours, so must add 1
			end_date.setDate(end_date.getDate() + 1);

			if (start_date.getMonth() > this.state.selected_month) {
				start_date.setDate(1);
			}

			let search_details = {
				fy: start_date.getFullYear(),
				fm: start_date.getMonth() + 1,
				fd: start_date.getDate(),
				ty: end_date.getFullYear(),
				tm: end_date.getMonth() + 1,
				td: end_date.getDate(),
				points: points,
			};

			this.search_date = start_date;
			this.props.receiver.getDailyMeter(search_details);
		} else if (this.state.tab == 'year') {
			// Check for report_settings start_date/month
			let date = 1;
			let month = 0;
			if (!isEmpty(this.props.param.report_settings)) {
				if (this.props.param.report_settings.start_day != null) date = this.props.param.report_settings.start_day;
				if (this.props.param.report_settings.start_month != null) month = this.props.param.report_settings.start_month;
			}

			start_date.setYear(this.state.y_selected_year);
			start_date.setMonth(month);
			start_date.setDate(date);
			end_date = new Date(start_date);
			end_date.setYear(end_date.getFullYear() + 1);

			let search_details = {
				fy: start_date.getFullYear(),
				fm: start_date.getMonth() + 1,
				fd: start_date.getDate(),
				ty: end_date.getFullYear(),
				tm: end_date.getMonth() + 1,
				td: end_date.getDate(),
				points: points,
			};

			this.search_date = start_date;
			this.props.receiver.getMonthlyMeter(search_details);
		}
	}

	rcvHourlyMeter = (hourly_meter) => {
		this.lastClickTime = false;
		window.app.hideLoading();
		if (isEmpty(hourly_meter.data)) {
			window.app.showToast(this.props.receiver.getString('no_data'), 3000);
		}

		this.setState({
			chart_data: getEnergyWaterChartData(this.props.param.report_type, hourly_meter, this.state.tab, this.state.selected_date, this.categories),
		}, this.chart.current.generateChart);
	}

	rcvDailyMeter = (daily_meter) => {
		this.lastClickTime = false;
		window.app.hideLoading();
		if (isEmpty(daily_meter.data)) {
			window.app.showToast(this.props.receiver.getString('no_data'), 3000);
		}

		this.setState({
			chart_data: getEnergyWaterChartData(this.props.param.report_type, daily_meter, this.state.tab, this.search_date, this.categories),
		}, this.chart.current.generateChart);
	}

	rcvMonthlyMeter = (monthly_meter) => {
		this.lastClickTime = false;
		window.app.hideLoading();
		if (isEmpty(monthly_meter.data)) {
			window.app.showToast(this.props.receiver.getString('no_data'), 3000);
		}

		let chart_data = getEnergyWaterChartData(this.props.param.report_type, monthly_meter, this.state.tab, new Date(this.search_date), this.categories);

		this.setState({
			year_info: this.getYearInfo(chart_data, new Date(this.search_date)),
			chart_data: chart_data,
		}, this.chart.current.generateChart);
	}

	getYearInfo = (chart_data, start_date) => {
		let year_info = [];
		if (chart_data[0] != null) {
			if (chart_data[0].length > 1) {
				let time_series = chart_data[0];

				for (let i = 1; i < time_series.length; i++) {
					let display_month = '';
					let temp_date = new Date(time_series[i]);
					display_month = temp_date.toLocaleString(locale, df_options2) + ')';

					if (start_date.getDate() > 15) {

					}
				}

				let from = new Date(start_date);
				let date = from.getDate();
				let month = from.getMonth();
				let locale = getLocale(window.app.receiver.lang);
				let df_options = { month: 'short', day: 'numeric' };
				let df_options2 = { month: 'short' };

				for (let i = 1; i < time_series.length; i++) {
					let display_month = '';
					//let temp_date = new Date(time_series[i]);

					let monthNum = time_series[i].substring(5, 7);

					switch(monthNum) {
						case '01':
							display_month = this.props.receiver.getString('mon0');
						  	break;
						case '02':
							display_month = this.props.receiver.getString('mon1');
						  	break;
						case '03':
							display_month = this.props.receiver.getString('mon2');
							break;
						case '04':
							display_month = this.props.receiver.getString('mon3');
							break;
						case '05':
							display_month = this.props.receiver.getString('mon4');
							break;
						case '06':
							display_month = this.props.receiver.getString('mon5');
							break;
						case '07':
							display_month = this.props.receiver.getString('mon6');
							break;
						case '08':
							display_month = this.props.receiver.getString('mon7');
							break;
						case '09':
							display_month = this.props.receiver.getString('mon8');
							break;
						case '10':
							display_month = this.props.receiver.getString('mon9');
							break;
						case '11':
							display_month = this.props.receiver.getString('mon10');
							break;
						case '12':
							display_month = this.props.receiver.getString('mon11');
							break;	  
						default:
							display_month = 'Invalid Date';
					}

					from.setDate(1);
					let to = new Date(from);

					from.setMonth(month); // month 
					from.setDate(date);
					if (from.getMonth() > month) {
						from.setDate(1);
					}

					to.setMonth(month + 1);
					to.setDate(date - 1);
					if (to.getMonth() > (month + 1)) {
						to.setDate(0);
					}

					let from_string = from.toLocaleString(locale, df_options);
					let to_string = to.toLocaleString(locale, df_options);
					year_info.push(display_month + ': ' + from_string + ' - ' + to_string);

					month++;
				}
			}
		}

		return year_info;
	}

	toggleShowYearInfo = () => {
		this.setState({ is_show_year_info: !this.state.is_show_year_info })
	}

	// Save as csv
	handleLeftButtonAction = () => {
		let Today = new Date();

		let report_type = ""
		if (this.props.param.report_type == "energy_management") report_type = "Energy_Management_Report_";
		else report_type = "Water_Management_Report_";

		let file_name = report_type + Today.getFullYear()
			+ (Today.getMonth() < 10 ? '0' : '') + (Today.getMonth() + 1)
			+ (Today.getDate() < 10 ? '0' : '') + (Today.getDate())
			+ '.csv';

		let csv = [];
		let chart_data = this.state.chart_data;
		let num_of_columns = chart_data[0].length;
		for (let x = 0; x < num_of_columns; x++) {
			let row = [];
			for (let index in chart_data) {
				let data = chart_data[index];
				if (data[x] == "x") row.push("");
				else row.push(data[x]);
			}
			csv.push(row.join(","));
		}
		handleDownloadCSV(csv.join("\n"), file_name);
	}

	render() {
		// Determine device orientation
		let is_landscape = this.props.width > this.props.height;

		let style = {
			textAlign: 'center',
			width: '100%',
		}

		let main_content_style = {
			position: 'fixed',
			top: 0,
			width: '100%',
			height: this.props.height,
			overflow: is_landscape ? 'auto' : 'none',
		}

		let select_style = {
			height: 30,
			textAlign: 'center',
			border: 'none',
			background: 'none',
			borderBottom: '1px solid' + this.props.colours.appBlue,
			outline: 'none',
			verticalAlign: 'top',
			cursor: 'pointer',
			display: 'inline-block',
			marginLeft: 10,
		}

		let content_height = 100;
		if (this.state.is_show_year_info) content_height = 'unset';

		let cal_width = this.props.width - 40;
		let cal_height = 200;

		// Check for report_settings start_date/month
		let start_date = 1;
		let start_month = 0;
		if (!isEmpty(this.props.param.report_settings)) {
			if (this.props.param.report_settings.start_day != null) start_date = this.props.param.report_settings.start_day;
			if (this.props.param.report_settings.start_month != null) start_month = this.props.param.report_settings.start_month;
		}

		let months_range = getChartMonthSelect(start_date, this.state.m_selected_year);

		let m_years_range = getYearSelect(2);

		let years_range = getYearSelectWithStartDate(2, start_month, start_date);

		let chart_width = this.props.width - 60;
		let chart_height = this.props.height - 280;

		if (chart_height < 300) chart_height = 300;

		return (
			<div style={style}>
				<div id='main_content' style={main_content_style} className='slideInDown noScrollBar'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString(this.props.param.report_type)}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
					/>
					<div id="content" className='noScrollBar' style={{ overflow: 'auto', height: this.props.height - 120 }}>
						<div style={{ marginTop: 10, verticalAlign: 'bottom', width: this.props.width, opacity: 0.95 }}>
							<span style={{ cursor: 'pointer', display: 'inline-block', marginLeft: 0, width: '33%', padding: '10px 0px', textAlign: 'center', backgroundColor: this.state.tab == 'day' ? this.props.colours.appBlue : 'white', color: this.state.tab == 'day' ? 'white' : 'black' }} onClick={() => this.handleShow('day')}>{this.props.receiver.getString('day')}</span>
							<span style={{ cursor: 'pointer', display: 'inline-block', marginLeft: 0, width: '33%', padding: '10px 0px', textAlign: 'center', backgroundColor: this.state.tab == 'month' ? this.props.colours.appBlue : 'white', color: this.state.tab == 'month' ? 'white' : 'black' }} onClick={() => this.handleShow('month')}>{this.props.receiver.getString('month')}</span>
							<span style={{ cursor: 'pointer', display: 'inline-block', marginLeft: 0, width: '33%', padding: '10px 0px', textAlign: 'center', backgroundColor: this.state.tab == 'year' ? this.props.colours.appBlue : 'white', color: this.state.tab == 'year' ? 'white' : 'black' }} onClick={() => this.handleShow('year')}>{this.props.receiver.getString('year')}</span>
						</div>
						<div>
							{(() => {
								switch (this.state.tab) {
									case 'day':
										return (
											<div style={{ width: '100%', height: content_height }}>
												<div onClick={this.toggleCalendar} style={{ cursor: 'pointer', paddingTop: 20, paddingLeft: 20, textAlign: 'left' }}>
													<span className='title'>{this.props.receiver.getString('date')
														+ ': ' + this.state.selected_date.toLocaleDateString()}</span>
												</div>
												<div className='slideInDown' style={{}}>
													<Calendar
														onSelect={this.handleChangeCalDate}
														style={{ visibility: this.state.is_show_calendar ? 'visible' : 'hidden' }}
														width={cal_width}
														height={cal_height}
														left={(this.props.width - 20) * 0.05}
														max_date={new Date()}
														selected_date={this.state.selected_date}
													/>
												</div>
											</div>
										);
										break;
									case 'month':
										return (
											<div style={{ width: '100%', height: content_height }}>
												<div style={{ paddingTop: 20, paddingLeft: 20, textAlign: 'left' }}>
													<span className='subtitle' style={{ fontSize: 20, display: 'inline-block', padding: 0, paddingLeft: 10 }}>{this.props.receiver.getString('year')}: </span>
													<select value={this.state.m_selected_year} style={select_style} onChange={(event) => this.handleChangeYear(event.target.value)}>
														{m_years_range}
													</select>
												</div>
												<div style={{ paddingLeft: 20, textAlign: 'left' }}>
													<span className='subtitle' style={{ fontSize: 20, display: 'inline-block', padding: 0, paddingLeft: 10 }}>{this.props.receiver.getString('month')}: </span>
													<select value={this.state.selected_month} style={select_style} onChange={(event) => this.handleChangeMonth(event.target.value)}>
														{months_range}
													</select>
												</div>
											</div>
										);
										break;
									case 'year':
										return (
											<div style={{ width: '100%', height: content_height }}>
												<div style={{ paddingTop: 20, paddingLeft: 20, textAlign: 'left', display: 'inline-block', width: this.props.width - 70 }}>
													<span className='subtitle' style={{ fontSize: 20, display: 'inline-block', padding: 0, paddingLeft: 10 }}>{this.props.receiver.getString('year')}: </span>
													<select value={this.state.y_selected_year} style={select_style} onChange={(event) => this.handleChangeYear(event.target.value)}>
														{years_range}
													</select>
												</div>
												<div style={{ display: 'inline-block', width: 30, marginRight: 20 }}>
													<div style={{ cursor: 'pointer', width: 20, height: 20, borderRadius: 10, border: '1px solid gray', marginLeft: 'auto', marginRight: 'auto' }} onClick={this.toggleShowYearInfo}>
														<span style={{ color: 'gray' }}>i</span>
													</div>
												</div>
												<div className='slideInDown' style={{ display: this.state.is_show_year_info ? 'block' : 'none', marginTop: 5, marginLeft: 25 }}>
													{this.state.year_info.map((year_info_string) => {
														return (
															<div style={{ textAlign: 'left' }}>
																<span className='footnote'> {year_info_string} </span>
															</div>
														)
													})}
												</div>
											</div>
										);
										break;
									default:
										return (
											<div></div>
										);
								}
							})()}
						</div>

						<div style={{ height: this.props.height - 200, overflow: is_landscape ? 'visible' : 'auto' }}>
							<Chart_Energy_Water
								report_type={this.props.param.report_type}
								style={{ zIndex: this.state.is_show_calendar ? -1 : 1 }}
								ref={this.chart}
								period={this.state.tab}
								chart_data={this.state.chart_data}
								chart_width={chart_width}
								chart_height={chart_height}
								receiver={this.props.receiver}
							/>
						</div>
					</div>
				</div>
			</div>
		)
	}
}